import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import EventSearch from '../../EventSearch'
import { EventCreate } from './EventActions'
import { useEvents } from 'app/hooks/Events/event'

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`

const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
`

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #0f172a;
`

const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
`

const Subtitle = styled.span`
  font-size: 14px;
  color: #64748b;
  font-weight: 400;
`

const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  width: 100%;

  @media (min-width: 768px) {
    justify-content: flex-end;
    width: auto;
    margin-left: auto;
  }
`

const AdminEventHeader = () => {
	const { searchApi, search: searchText } = useEvents()
	const [search, setSearch] = useState(searchText)

	useEffect(() => {
		setSearch(searchText)
	}, [searchText])

	const searchData = (value: string) => {
		setSearch(value)
		searchApi(value)
	}

	return (
		<HeaderWrapper>
			<HeaderRow>
				<TitleBlock>
					<Title>이벤트 관리</Title>
					<Subtitle>프로모션과 공지를 한 곳에서 등록 · 수정 · 삭제하세요.</Subtitle>
				</TitleBlock>
				<Controls>
					<EventSearch search={search} searchData={searchData} />
					<EventCreate />
				</Controls>
			</HeaderRow>
		</HeaderWrapper>
	)
}

export default AdminEventHeader
